import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsManufacturingNameStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const manufacturingNameStyles: ProductDetailsManufacturingNameStyles = {
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 15px;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
        `,
    },
};

const styles = manufacturingNameStyles;

const ProductDetailsManufacturingName: React.FC<Props> = ({ product }) => {
    const isCmiProduct = product.properties["isCmiProduct"]?.toLowerCase() === "true";
    const manufacturerName = product.properties["manufacturerNameValue"];

    if (!manufacturerName || isCmiProduct) {
        return null;
    }
    return (
        <Typography {...styles.valueText} as="p" data-test-selector="manufacturing-name">
            <Typography {...styles.labelText}>{translate("Manufacturer")}:</Typography>
            {manufacturerName}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsManufacturingName),
    definition: {
        displayName: "Manufacturing Name",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
